import { render, staticRenderFns } from "./contentList.vue?vue&type=template&id=f3db8c90&"
import script from "./contentList.vue?vue&type=script&lang=js&"
export * from "./contentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports